/**
 * @import {BookInfoConfig} from "../../src/UI/BookInfo.ts"
 */
export class BookInfoModel {
	/**
	 * @constructor
	 * @param {BookInfoConfig} config
	 */
	constructor(config) {
		this.title = config.title;
		this.author = config.author;
		this.publisher = config.publisher;
		this.isbn = config.isbn13;
		this.genre = config.genre;
		this.publicationDate = config.publication_date_string;
		this.buyLink = config.buy_link;
		this.buyLinkNav = config.buy_link_nav;
		this.buyLinks = config.buy_links;
		this.shareLink = config.share_link;
	}
}
